/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'

export default class CommunesField extends React.PureComponent {
  render() {
    const { onChange, communes, selectedCommunes } = this.props

    const data = _.reduce(
      communes,
      (result, commune) => {
        const option = {
          label: commune.name,
          value: commune.id,
        }

        if (selectedCommunes.includes(commune.id)) {
          result.existedValue.push(option)
        }

        result.options.push(option)

        return result
      },
      { existedValue: [], options: [] }
    )

    const selectAll = { label: 'Select all', value: 'select-all'}
    return (
      <Form.Field>
        <label>Communes</label>
        <Select
          menuPlacement="top"
          isMulti
          isClearable
          isSearchable
          isRtl={false}
          isDisabled={false}
          value={data.existedValue}
          className="basic-single"
          onChange={onChange}
          options={[ selectAll, ...data.options ]}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/serviceAvailability/components/CommunesField.js